import zionDebug from '@fs/zion-debug'
import { filterIllegalReviewFieldCharacters } from '../../../../shared/utils/utils'

const debug = zionDebug('rip:FullNameCorrection:reducer')

export const defaultInitialState = {
  highlights: [], // All highlights pulled from the sls data (we only want to pull this when changing images or after saving the data)
  editHighlights: [], // Temporary state of highlights during editing
  stepThree: {},
  stepFour: {},
  userId: '',
  creatingRect: false,
  activeFieldId: '',
  selectedPersonId: '',
  userPerformedFix: false,
  noGivenOrSurnameError: false,
  emptyGivenOrSurnameError: false,
  tasksMarkedNotAPerson: [],
  currentNameParts: {},
}
// eslint-disable-next-line no-warning-comments
// TODO: Show structure of each step state here
// stepThree: {
//   NAME_GN: {
//     fields: [
//         { // starting of the field
//           "elementType": "FIELD",
//           "partitionKey": "3:1:3Q4B-MQHC-6Z1",
//           "id": "8e18d98f-23be-4a8c-8923-72f2ef4a5242",
//           "superElements": [
//             {
//               "partitionKey": "3:1:3Q4B-MQHC-6Z1",
//               "id": "a32db0cd-fe88-4517-b389-ad9ff08d9e42"
//             }
//           ],
//           "fieldType": "NAME_GN",
//           "highlightIds": [],
//           "rects": [
//             {
//               "x1": 0.17871539908626713,
//               "y1": 0.26011690647482016,
//               "x2": 0.22655200214995969,
//               "y2": 0.2704586330935252
//             }
//           ],
//           "fieldValues": [
//             {
//               "origValue": {
//                 "text": "Gage"
//               }
//             }
//           ],
//           "typeData": {
//              ...properties
//            },
//           "confidence": "0.9593081",
//           "userEnteredValue": "Bernice", // The value the entered
//         }
//       ]
//     },
//     NAME_SURN: {
//       fields: [
//         {
//           ...
//         }
//       ]
//     }
//   }

// stepFour: {
//   NAME_GN: {
//     text: textValue, // e.g. Bernice Joy Elizabeth where Joy was added by the user
//     highlightIds: []
//    }
//   NAME_SURN: {
//     text: textValue, // ditto
//     highlightIds: []
//    }
//   ... and so on for each part
// }

export default function reducer(state, action) {
  debug('reducer called: ', state, action.type, action)

  switch (action.type) {
    case 'SET_USER_PERFORMED_FIX':
      return { ...state, userPerformedFix: true }
    case 'BATCH_DISPATCHES':
      return action.value.reduce(reducer, state)
    case 'SET_USER_ID':
      return { ...state, userId: action.value }
    case 'SET_CURRENT_NAME_PARTS': {
      const noGiveOrSurnameField = !(action.value?.NAME_GN?.fields.length || action.value?.NAME_SURN?.fields.length)

      // Removes illegal characters from the review field values
      const treatNamePartValues = (actionValue) => {
        const entries = Object.entries(actionValue)
        entries.forEach(([, value]) => {
          const namePartFields = value.fields
          if (namePartFields.length) {
            namePartFields.forEach((field) => {
              field.userEnteredValue = filterIllegalReviewFieldCharacters(field.userEnteredValue)
            })
          }
        })
      }

      treatNamePartValues(action.value)

      return {
        ...state,
        stepThree: action.value,
        currentNameParts: action.value,
        noGivenOrSurnameError: noGiveOrSurnameField,
        emptyGivenOrSurnameError: noGiveOrSurnameField,
      }
    }
    case 'SET_ACTIVE_FIELD_ID': {
      return {
        ...state,
        activeFieldId: action.value,
      }
    }
    case 'SET_SELECTED_PERSON_ID': {
      return {
        ...state,
        selectedPersonId: action.value,
      }
    }
    case 'ADD_TO_NOT_PERSON_TASKS': {
      return {
        ...state,
        tasksMarkedNotAPerson: [...state.tasksMarkedNotAPerson, action.value],
      }
    }
    case 'REMOVE_FROM_NOT_PERSON_TASKS': {
      return {
        ...state,
        tasksMarkedNotAPerson: [...state.tasksMarkedNotAPerson.filter((napTask) => napTask !== action.value)],
      }
    }
    default: {
      throw new Error(`Unhandled type in Full Name reducer: ${action.type}`)
    }
  }
}
